<div
  class="px-3 py-2 bg-white rounded-sm min-w-[90px] max-w-max shadow-2xl flex items-center gap-2 m-2 ms-auto"
>
  <svg-icon src="/icons/clock.svg" svgClass="w-5 h-5 text-primary" />
  {{ expiryTimer() }}
</div>
